export enum AdressInputType {
  Input,
  InputReadOnly,
  Dropdown,
}
